// Copyright (c) 2017 Deere & Company

import t from 'tcomb';

const WipPips = t.struct({
    currentPinsCount: t.Number,
    expiredCount: t.Number,
    pinsExpiringInNext90Days: t.Number
}, {
    name: 'WipPips',
    strict: true
});

export const getDefaultState = () => new WipPips({
    currentPinsCount: 0,
    expiredCount: 0,
    pinsExpiringInNext90Days: 0
});

export default WipPips;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/wip-pips.js